import { render, staticRenderFns } from "./genelamacliraporcoper.vue?vue&type=template&id=643d9333&scoped=true"
import script from "./genelamacliraporcoper.vue?vue&type=script&lang=js"
export * from "./genelamacliraporcoper.vue?vue&type=script&lang=js"
import style0 from "./genelamacliraporcoper.vue?vue&type=style&index=0&id=643d9333&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643d9333",
  null
  
)

export default component.exports